export enum THEME_COLORS {
  SUCCESS = 'success',
  DEEFAULT = 'default',
}

export interface Props {
  id: string;
  title: string;
  isLoading?: boolean;
  value: number;
  valueTheme?: THEME_COLORS;
  hint: string;
  isCtaDisabled?: boolean;
  ctaCopy?: string;
  ctaButtonTooltip?: string;
  ctaCallback?: () => void;
  ctaAccessControl?: string;
  bottomExtra?: React.ReactNode;
}
